import { V } from '../misc/Vector.js';
export { Intersection };
class Intersection {
    static circleCircle(centerA, radiusA, centerB, radiusB) {
        const c = V.subtract(centerB, centerA), rAs = radiusA * radiusA, rs = rAs - radiusB * radiusB, cs = V.squaredNorm(c), cl = V.norm(c), rd = Math.abs(radiusA - radiusB);
        if (cl > radiusA + radiusB || cl < rd) {
            return [];
        }
        else if (cl === 0 && radiusA === radiusB && radiusA !== 0) {
            return true;
        }
        else if (cl === 0 && radiusA === radiusB && radiusA === 0) {
            return [centerA];
        }
        const t = V.multiply(c, .5 * (rs / cs + 1)), ts = V.squaredNorm(t), ct = V.add(centerA, t), l = Math.sqrt(Math.abs(rAs - ts));
        if (l === 0) {
            return [ct];
        }
        const p = V.normalize([-c[1], c[0]]);
        return [
            V.add(ct, V.multiply(p, l)),
            V.add(ct, V.multiply(p, -l))
        ];
    }
    /*static arcSegment(arcCenter: Point, arcRadius: number, arcStartAngle: number, arcEndAngle: number, arcClockWise: boolean, segmentPoint1: Point, segmentPoint2: Point, arcInclusive: boolean = true, segmentInclusive: boolean = true, noCollisionIfBothEndpoints: boolean = false, fullCircleFlag: boolean = false): [] | Point | [Point, Point] {
      const sxd = segmentPoint2[0] - segmentPoint1[0],
      syd = segmentPoint2[1] - segmentPoint1[1],
      sr = Math.hypot(sxd, syd),
      srdiv = 1 / sr,
      srs = sxd * sxd +  syd * syd,
      d = segmentPoint1[0] * segmentPoint2[1] - segmentPoint2[0] * segmentPoint1[1],
      dis = arcRadius * arcRadius * srs - d

      const isValid = function(point: Point) {
        const
        psxd = point[0] - segmentPoint1[0],
        psyd = point[1] - segmentPoint1[1],
        l = Math.hypot(psxd, psyd)

      }

      let result: [] | Point | [Point, Point]

      if(dis < 0) {
        result =  []
      } else {

        const rt = Math.sqrt(dis),
        xt1 = d * syd,
        yt1 = -d * sxd,
        xt2 = (syd < 0 ? -1 : 1) * sxd * rt,
        yt2 = Math.abs(syd) * rt,
        div = 1 / srs

        if(dis === 0) {
          const p: Point = [(xt1 + xt2) * div, (yt1 + yt2) * div]
          result = p
        } else {
          result = [[(xt1 + xt2) * div, (yt1 + yt2) * div], [(xt1 - xt2) * div, (yt1 - yt2) * div]]
        }
      }

      return result

    }*/
    static segmentSegment(lineAPoint1, lineAPoint2, lineBPoint1, lineBPoint2, lineAInclusive = true, lineBInclusive = true, noCollisionIfBothEndpoints = false) {
        const aX1 = lineAPoint1[0], aY1 = lineAPoint1[1], aX2 = lineAPoint2[0], aY2 = lineAPoint2[1], bX1 = lineBPoint1[0], bY1 = lineBPoint1[1], bX2 = lineBPoint2[0], bY2 = lineBPoint2[1], aXd = aX1 - aX2, aXdi = -aXd, aYd = aY1 - aY2, aYdi = -aYd, abX1d = aX1 - bX1, abY1d = aY1 - bY1, bXd = bX1 - bX2, bYd = bY1 - bY2, d = aXd * bYd - aYd * bXd, r = abX1d * bYd - abY1d * bXd, s = aXdi * abY1d - aYdi * abX1d, t = r / d, u = s / d;
        if (d === 0) {
            return -1;
        }
        else {
            if (lineAInclusive && (t < 0 || 1 < t)) {
                return undefined;
            }
            else if (!lineAInclusive && (t <= 0 || 1 <= t)) {
                return undefined;
            }
            if (lineBInclusive && (u < 0 || 1 < u)) {
                return undefined;
            }
            else if (!lineBInclusive && (u <= 0 || 1 <= u)) {
                return undefined;
            }
            if (noCollisionIfBothEndpoints && (t === 0 || t === 1) && (u === 0 || u === 1)) {
                return undefined;
            }
            return [aX1 + aXdi * t, aY1 + aYdi * t];
        }
    }
    static raySegment(rayPoint, rayDirection, segmentPoint1, segmentPoint2, rayInclusive = true, segmentInclusive = true, noCollisionIfBothEndpoints = false) {
        const aX1 = rayPoint[0], aY1 = rayPoint[1], aX2 = aX1 + rayDirection[0], aY2 = aY1 + rayDirection[1], bX1 = segmentPoint1[0], bY1 = segmentPoint1[1], bX2 = segmentPoint2[0], bY2 = segmentPoint2[1], aXd = aX1 - aX2, aXdi = -aXd, aYd = aY1 - aY2, aYdi = -aYd, abX1d = aX1 - bX1, abY1d = aY1 - bY1, bXd = bX1 - bX2, bYd = bY1 - bY2, d = aXd * bYd - aYd * bXd, r = abX1d * bYd - abY1d * bXd, s = aXdi * abY1d - aYdi * abX1d, t = r / d, u = s / d;
        if (d === 0) {
            return -1;
        }
        else {
            if (rayInclusive && (t < 0)) {
                return undefined;
            }
            else if (!rayInclusive && t <= 0) {
                return undefined;
            }
            if (segmentInclusive && (u < 0 || 1 < u)) {
                return undefined;
            }
            else if (!segmentInclusive && (u <= 0 || 1 <= u)) {
                return undefined;
            }
            if (noCollisionIfBothEndpoints && t === 0 && (u === 0 || u === 1)) {
                return undefined;
            }
            return [aX1 + aXdi * t, aY1 + aYdi * t];
        }
    }
}
//# sourceMappingURL=Intersection.js.map